<template>
  <div class="review-report-body">
    <div class="report-wrap has-file flex">
      <!--   目录   -->
      <div class="catalog-list m-r-16">
        <el-scrollbar class="m-t-24" style="height: calc(100% - 60px)">
          <el-tree
            ref="tree"
            :data="treeData"
            show-checkbox
            default-expand-all
            node-key="attachmentId"
            highlight-current
            :props="{ label: 'reportName' }"
            @node-click="onCatalogTreeSelect"
          />
        </el-scrollbar>
      </div>
      <!--   pdf文件预览   -->
      <div class="pdf-preview">
        <div class="iframe-wrap">
          <iframe
            :src="`/pdfjs/web/viewer.html?file=${encodeURIComponent(fileUrl)}`"
            frameborder="0"
            class="frame"
          ></iframe>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import useOnlineReviewReport from '@/components/online-review/hooks/useOnlineReviewReport'

import {
  downloadPurchaseReviewReportApi
} from '@/api/procure/purchase-review'
export default {
  props: {
    reviewProject: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      reviewId: '',
      reviewModel: '',
      catalogList: [],
      // 当前查看的评标报告文件地址
      fileUrl: '',
      treeData: []
    }
  },

  watch: {
    reviewProject: {
      handler: function(val) {
        if (val?.reviewId) {
          this.reviewId = val?.reviewId
          this.reviewModel = val?.reviewInfo.reviewModel
          this.catalogList = (val?.reportInfoList || []).map(item =>
            useOnlineReviewReport().getCatalogConfig(item)
          )
          if (this.catalogList.length) {
            this.inDefault = false
            this.treeData = [
              {
                reportName: '全部',
                attachmentId: 0,
                children: this.catalogList.map(item => {
                  return {
                    children: [],
                    ...item
                  }
                })
              }
            ]
          } else {
            this.catalogList = useOnlineReviewReport().getReportCatalogList(
              this.reviewModel
            )
          }
        }
      },
      immediate: true,
      deep: true
    }
  },

  methods: {

    /**
     * 目录树勾选事件
     */
    onCatalogTreeSelect(info, node) {
      if (!info.attachmentId) return
      downloadPurchaseReviewReportApi(this.reviewId, {
        attachmentId: info.attachmentId
      })
        .then(res => {
          this.fileUrl = res.data
        })
        .catch(err => {
          if (err?.message) this.$message.error(err.message)
          throw err
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.review-report-body {
  display: flex;
  width: 100%;
  height: calc(100% - 60px);
  background: $white-color;
  .report-wrap {
    width: 100%;
    height: calc(100% - 100px);
    overflow: auto;

    &.no-file {
      background: $white-color;
      border-radius: 4px;
    }

    &.has-file {
      height: 890px;
    }
  }
}

.catalog-list {
  width: 300px;
  height: 100%;
  background: $white-color;
  border-radius: 4px;
  box-sizing: border-box;
  padding: 16px 0px 26px 24px;
  overflow: hidden;

  ::v-deep .el-scrollbar__wrap {
    overflow-x: hidden;
  }
}

.pdf-preview {
  width: 100%;
  height: 100%;
  background: #fff;
  border-radius: 4px;

  .iframe-wrap {
    width: 100%;
    height: 100%;

    .frame {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
